import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function PublicLayout() {
  const { user } = useAuth();

  if (user) return <Navigate to="/" replace />;

  return (
    <div className="bg-[#F0F2F5] min-h-screen flex items-center">
      <div className="w-screen px-5">
        <Outlet />
      </div>
    </div>
  );
}
